// Important! Do not edit this file - it is auto-generated by generate_emojis.sh
export const files = new Set([
    "cactus.svg",
    "cogs.svg",
    "dead.svg",
    "elf.svg",
    "elton.svg",
    "evil.svg",
    "ghost.svg",
    "goat_eyes.svg",
    "inverse.svg",
    "lady.svg",
    "pray.svg",
    "random.svg",
    "serene.svg",
    "shrug.svg",
    "updates.svg",
    "upside_down.svg",
    "vampire.svg",
    "wheel.svg",
    "wild.svg",
    "wink.svg",
]);
